import { useMutation } from 'query';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- TODO: fix according to result of #67489
import { markAsRead } from 'features/programs/services';
import { useUpdateMarkAsRead } from '../../hooks';

export const useMarkAsRead = () => {
  const updateCache = useUpdateMarkAsRead();

  return useMutation<
    unknown,
    {
      postId: string;
    }
  >({
    async mutationFn({ postId }) {
      const response = await markAsRead({ id: postId });

      return response.data;
    },
    onSuccess(_data, params) {
      updateCache(params);
    },
  });
};
